function getStep3State(state) {
  return {
    features: state.step3Module1.features,
    featureCategories: state.step3Module1.featureCategories,
    featuresOriginal: state.step3Module1.featuresOriginal,
    textInputsValues: state.step3Module1.textInputsValues
  };
}

export { getStep3State };
